/**
 * apple-login-v1 — the Apple logotype for the "Sign in with Apple" button.
 *
 * Extracted from the design-only slot in `routes/native-welcome.tsx` (the
 * path data is unchanged) so all three sign-in surfaces share one mark —
 * exactly the reason `GoogleGMark` was extracted in mobile-v1 D5.
 *
 * WHITE ONLY, deliberately. Apple's "Sign in with Apple" guidelines permit
 * a black button with a white mark, or a white button with a black mark,
 * and nothing else — the mark may never be recolored or placed on a
 * brand fill. Every Tayro sign-in surface is a light/cream page, so all
 * three use the BLACK button, which fixes the mark at white. If a dark
 * surface ever hosts this button it takes the white-button variant and
 * this component gains a colour prop then, not speculatively.
 */
export function AppleMark({
  size = 17,
  className,
}: {
  size?: number;
  className?: string;
}): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 20"
      aria-hidden="true"
      className={className}
    >
      <path
        fill="#fff"
        d="M14.06 15.6c-.26.6-.57 1.16-.93 1.67-.5.7-.9 1.18-1.2 1.45-.47.44-.98.66-1.52.68-.39 0-.86-.11-1.4-.34-.55-.22-1.05-.33-1.51-.33-.48 0-1 .11-1.55.33-.56.23-1 .35-1.34.36-.52.02-1.04-.21-1.56-.69-.33-.29-.74-.79-1.25-1.5-.54-.76-.99-1.64-1.34-2.65C.6 15.13.36 13.93.36 12.77c0-1.33.29-2.48.86-3.44a5.06 5.06 0 0 1 1.8-1.83 4.85 4.85 0 0 1 2.44-.69c.41 0 .96.13 1.64.38.68.25 1.12.38 1.31.38.14 0 .62-.15 1.44-.45.77-.28 1.42-.4 1.96-.35 1.45.12 2.54.69 3.27 1.72-1.3.79-1.94 1.89-1.93 3.3.01 1.1.41 2.02 1.2 2.74.36.34.76.6 1.2.79-.1.28-.2.54-.31.79zM11.5 1.4c0 .99-.36 1.92-1.09 2.77-.87 1.02-1.93 1.6-3.08 1.51a3.1 3.1 0 0 1-.02-.37c0-.95.42-1.97 1.15-2.8.37-.42.83-.77 1.4-1.05.56-.27 1.09-.42 1.59-.45.02.13.05.26.05.39z"
      />
    </svg>
  );
}
